export const EMAIL_BASE_LIST = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "aol.com",
  "msn.com",
  "proton.me",
  "icloud.com",
  "outlook.com",
  "outlook.de",
  "gmx.de",
  "web.de",
  "t-online.de",
  "yahoo.de",
  "freenet.de",
  "posteo.de",
  "mail.de",
];
